import React, {useRef, useState} from "react";
import useOutsideClickHandler from '../base/useOutsideClickHandler';

export default function CustomSelect(props) {

    const [active, setActive] = useState(false);
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => setActive(false));
    const  usersFilterValues = [{label: 'All Users', value: 'all'},
        {label: 'Unconfirmed Users', value: 'unconfirmed'},
        {label: "Confirmed Users", value: 'confirmed'}];



    return (
         <div className={`users__dropdown-container ${active ? 'active' : ''}`} ref={wrapperRef}>
             <label className={`users__dropdown users__dropdown--label`} onClick={() => setActive(!active)}><span className="users__dropdown--label__title">
                 {usersFilterValues.find((v) => v.value === props.user_status).label}
             </span></label>
             <div className="users__dropdown users__dropdown--list">
                 {usersFilterValues.map((status) => {
                     return <label className="users__dropdown__option input-tick addAnimation" key={status.value}>
                         <input type="checkbox" name="user_filter"
                                onChange={props.onChange}
                                value={status.value}
                                checked={props.user_status === status.value}/>
                         <span className="checkbox-material"><span className="custom-checkbox"/></span>
                         <span className="check-text">{status.label}</span>
                     </label>;
                 })}
             </div>
         </div>
     )

}
